import styled from 'styled-components';

import Link from '../../Components/Core/Link';
import Paragraph from '../../Components/Custom/Paragraph';

export const Wrapper = styled.div`
  position: relative;
  margin: 0 auto;

  .related-faqs-wrapper,
  .related-faqs {
    margin: 0 auto !important;
  }
`;

export const Heading = styled.h1`
  position: relative;
  margin: 0 auto;
  text-align: center;
  font-size: 2rem;
  line-height: 1.5;
`;

export const DownloadLink = styled(Link)`
  position: relative;
  display: flex;

  span {
    margin-left: ${({ icon }) => (icon ? '0.35rem' : '0px')};
  }

  &::after,
  &::before {
    height: 25px;
    width: 25px;
    margin-bottom: -3px;
    display: inline-block;
  }
`;

export const StyledParagraph = styled(Paragraph)`
  margin-top: 0;
`;
